import request from '@/utils/axios';

export const getWork                = p  => request.get(`/community/open/work/${p}`);
export const greatWork              = p  => request.put(`/community/open/work/${p}`);
export const getPublishWork         = p  => request.get(`/community/open/work/publish/${p}`);
export const listPublishWork        = p  => request.get('/community/open/work/publish', {params: p});
export const getWorks               = p  => request.get('/community/work', {params: {release: p}});
export const saveOrUpdateWork       = p  => request.post('/community/work', p);
export const publishWork            = p  => request.put('/community/work', p);
export const deleteWork             = p  => request.delete(`/community/work/${p}`);
export const getFavorites           = () => request.get('/community/work/fav');
export const toggleWorkFavorite        = p  => request.post(`/community/work/fav/${p}`);
